<template>
  <div>
    <div class="video_write">
      <img @click="videoWrite()" src="@/assets/img/video_write.svg" />
    </div>

    <recomVideoPop :visible="isRecomPop" :recom="recom" @close="popClose"></recomVideoPop>
    <div class="wrap recom-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>고객 / 코칭 일지</h3>
      </div>
      <div class="body-wrap" style="padding-bottom: 150px">
        <incMenuShot></incMenuShot>
        <div v-for="(item, index) in recomList" :key="index">
          <h6>{{ item[0].recomDate }}</h6>
          <ul class="video-list">
            <li @click="showRecomPop(subItem)" v-for="(subItem, subIndex) in item" :key="subIndex">
              <div class="list-wrap">
                <h5>
                  <img :src="subItem.thum" alt="썸네일" />
                </h5>
                <p>
                  {{ subItem.contentReasonsRecommendation }}
                  <span>{{ subItem.recomDate }}</span>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import incTab from "@/components/inc/inc_tab.vue";
import incMenuShot from "@/components/inc/inc_menu_shot.vue";
import { groupBy } from "@/utils/common";
import dayjs from "dayjs";
import recomVideoPop from "@/components/pop/recom_video_pop.vue";
export default {
  name: "recom_video",
  data: () => ({
    isLayer: false,
    recomList: [],
    recom: {
      contentTitle: "",
      contentReasonsRecommendation: "",
      contentVideoUrl: "",
      recomDate: "",
      contentIdx: "",
    },
    isRecomPop: false,
  }),
  components: {
    incBack,
    incTab,
    incMenuShot,
    recomVideoPop,
  },
  mounted() {
    this.getRecommendContents();
  },
  methods: {
    popClose() {
      this.isRecomPop = false;
      this.getRecommendContents();
    },
    showRecomPop(recomItem) {
      this.recom.contentTitle = recomItem.contentTitle;
      this.recom.contentReasonsRecommendation = recomItem.contentReasonsRecommendation;
      this.recom.contentVideoUrl = recomItem.contentVideoUrl;
      this.recom.recomDate = recomItem.recomDate;
      this.recom.contentIdx = recomItem.contentIdx;
      console.log(this.recom);
      this.isRecomPop = true;
    },
    getRecommendContents() {
      this.axios
        .get(`/content/coach/${this.$store.state.userInfo.userIdx}?page=1`)
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            let temp = res.data.data;
            for (let item of temp) {
              item.recomDate = dayjs(item.contentCreatedDatetime).format("YYYY-MM-DD");

              let replaceUrl = item.contentVideoUrl;
              let finUrl = "";
              replaceUrl = replaceUrl.replace("https://m.youtube.com/watch?v=", "");
              replaceUrl = replaceUrl.replace("https://youtu.be/", "");
              replaceUrl = replaceUrl.replace("https://www.youtube.com/embed/", "");
              replaceUrl = replaceUrl.replace("https://www.youtube.com/watch?v=", "");
              finUrl = replaceUrl.split("&")[0];
              console.log(finUrl);
              // console.log("finurl",finUrl);
              item.thum = `https://img.youtube.com/vi/${finUrl}/mqdefault.jpg`;
            }
            this.recomList = groupBy(temp, "recomDate");
            console.log(this.recomList);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    videoWrite() {
      // this.$router.push("video_write");
      this.$router.push({ name: "video_write", params: { isRetake: 0 } });
    },
  },
};
</script>
